<ion-modal [isOpen]="displayWarningModal">
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-button color="medium" (click)="closeWarningModal()">{{ 'OK' | translate }}</ion-button>
                  </ion-buttons>
                <ion-title>{{ title }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <div class="text-align-center">
                {{ description }}
            </div>
        </ion-content>
    </ng-template>
</ion-modal>